<!--template>
	<el-table-column v-bind="{ ...bindDesc(desc), ...passive }">
		<template #header="scope">
			<slot name="header" v-bind="{ desc, ...scope }">
				<span>{{ bindLabel(desc) }}</span>
			</slot>
		</template>
		<template #default="scope">
			<slot name="default" v-bind="scope">
				<span>{{ bindData(scope.row, desc.prop) }}</span>
			</slot>
		</template>
	</el-table-column>
</template-->

<script>
	import { TableColumn } from 'element-ui';

	const defaultBindLabel = (item) => item.label;
	const defaultBindData = function(scope, desc) {
		return scope.row[desc.prop];
	};
	const defaultBindDesc = function(item) {
		return {
			align: item.align,
			minWidth: item.width,
		};
	};

	export default {
		name: 'colDefiner',
		props: {
			desc: {
				type: Object,
				default: () => {
					return {
						prop: '',
						label: '',
					};
				},
			},
			col: {
				type: String,
				require: true,
			},
			passive: {
				type: Object,
				default: () => {
					return {};
				},
			},
			bindLabel: {
				type: Function,
				default: defaultBindLabel,
			},
			bindData: {
				type: Function,
				default: defaultBindData,
			},
			bindDesc: {
				type: Function,
				default: defaultBindDesc,
			},
		},
		render(h) {
			//先判断是否有特殊情况,随后根据传入的slot判断使用默认的槽位还是使用用户自定义的槽位
			const isSelection = this.passive.type === 'selection';
			const hasHeader = Boolean(this.$scopedSlots.header);
			const hasDefault = Boolean(this.$scopedSlots.default);
			const scopedSlots = {};

			if (!isSelection) {
				if (hasHeader) {
					scopedSlots.header = (scope) => {
						return this.$scopedSlots.header({ desc: this.desc, ...scope });
					};
				} else {
					scopedSlots.header = () => {
						return <span>{this.bindLabel(this.desc)}</span>;
					};
				}
				if (hasDefault) {
					scopedSlots.default = (scope) => {
						return this.$scopedSlots.default({ desc: this.desc, ...scope });
					};
				} else {
					scopedSlots.default = (scope) => {
						return <span>{this.bindData(scope, this.desc)}</span>;
					};
				}
			}

			const attrs = { ...this.bindDesc(this.desc), ...this.passive };

			return <TableColumn scopedSlots={scopedSlots} {...{ attrs }}></TableColumn>;
		},
	};
</script>
